import React, { useEffect } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import InputName from "../../common/Input/InputName";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getServiceSlice } from "../../../store/slices/serviceSlice";
import InputNumber from "../../common/Input/InputPhNumber";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import InputImage from "../../common/Input/InputImage";
import InputText from "../../common/Input/InputText";

const AddUpdateCamp = ({
  camp,
  showModal,
  setModalVisible,
  formData,
  handleChange,
  handleFileChange,
  modalAction,
  handleAddOrUpdateCamp,
  setInputError,
  serviceOptions,
  imagePreview,
  handleServiceChange,
}) => {
  const { services } = useSelector((state) => state.service);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getServiceSlice({ status: ["Active"], token }));
  }, [dispatch, showModal, token]);
  return (
    <Modal
      show={showModal}
      onHide={() => setModalVisible(false)}
      centered
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create" ? "Add Camp" : "Edit Camp"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        ></button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleAddOrUpdateCamp}>
          <div className="row">
            {/* Camp Name Input */}
            <div className="col-xl-6">
              <div className="form-group">
                <InputName
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter camp name"
                  label="Name"
                  setInputNameError={setInputError}
                  required={true}
                />
              </div>
            </div>

            {/* Organized By Input */}
            <div className="col-xl-6">
              <div className="form-group">
                <InputName
                  name="organizer"
                  value={formData.organizer}
                  onChange={handleChange}
                  placeholder="Enter organizer name"
                  label="Organized By"
                  setInputNameError={setInputError}
                  required={true}
                />
              </div>
            </div>

            {/* Phone Input */}
            <div className="col-xl-6">
              <div className="form-group">
                <InputNumber
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  label="Mobile"
                  placeholder={"Enter mobile number"}
                  setInputNumberError={setInputError}
                />
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group">
                <label htmlFor="service" className="col-form-label">
                  Services:
                </label>
                <Select
                  id="service"
                  value={formData.service?.value ? formData.service : null}
                  placeholder="Select Services"
                  options={services?.map((service) => ({
                    value: service?._id,
                    label: service?.serviceName,
                  }))}
                  onChange={(e) => handleChange(e, "services")}
                />
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group position-relative">
                <InputText
                  name="address"
                  value={formData?.address}
                  onChange={handleChange}
                  label="Address"
                  placeholder={"Enter address"}
                />
              </div>
            </div>

            {/* Image Upload */}
            <div className="col-xl-6">
              <div className="form-group">
                <Form.Group controlId="campImage">
                  <InputImage
                    name="campImage"
                    onChange={handleFileChange}
                    placeholder="Photo"
                    setInputImgError={setInputError}
                    label={"Image"}
                    multiple={false}
                    required={false}
                    minSize={10 * 1024}
                    maxSize={1 * 1024 * 1024}
                    value={formData?.campImage}
                  />

                  {(imagePreview.campImage || formData.campImage) && (
                    <div className="mt-3">
                      <Image
                        src={imagePreview.campImage || formData.campImage}
                        alt="Image Preview"
                        style={{ width: "40%", height: "40%" }}
                      />
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>

            {/* Description Input */}
            <div className="col-xl-12">
              <div className="form-group">
                <label htmlFor="description" className="col-form-label">
                  Description:
                </label>
                <CKEditor
                  name="remark"
                  editor={ClassicEditor}
                  data={formData.remark}
                  onChange={(event, editor) => handleChange({ editor })}
                />
              </div>
            </div>

            {/* Status Radio Buttons */}
            <div className="col-xl-6">
              <div className="form-group d-flex align-items-center">
                <label htmlFor="status" className="col-form-label me-3">
                  Status:
                </label>
                {["Active", "Inactive", "Deleted"].map((status) => (
                  <div className="form-check me-3" key={status}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id={status.toLowerCase()}
                      value={status}
                      checked={formData.status === status}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={status.toLowerCase()}
                    >
                      {status}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </Button>
            <Button type="submit" className="btn btn-success">
              {modalAction === "create" ? "Add Camp" : "Update Camp"}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default AddUpdateCamp;
